// Whitelist of valid props to be passed to a SVG DOM node. Used for preventing
// unknown-prop errors when rendering tick labels in both hero and card charts.
// ref: https://facebook.github.io/react/warnings/unknown-prop.html
export const validTickLabelNodeProps = [
    'fill',
    'height',
    'stroke',
    'textAnchor',
    'width',
    'x',
    'y',
];
